import React from "react";
import {Paper, Typography, Divider, useTheme, Snackbar, Alert} from "@mui/material";
import Grid from "@mui/material/Grid2"
import InfoIcon from "@mui/icons-material/Info";

export type Accessory = {
    articleNumber: string;
    description: string;
    price: number;
    count: number;
    unit: string;
};

type AccessoriesPanelProps = {
    accessories: Accessory[];
};

export const AccessoriesPanel: React.FC<AccessoriesPanelProps> = ({accessories}) => {

    const theme = useTheme()
    const [snackbar, setSnackbar] = React.useState("");

    const handleSnackBarClose = (event: any, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar("");
    };

    return (
        <Paper square sx={{background: "white", padding: 4}}>
            <Snackbar
                open={snackbar.length > 0}
                autoHideDuration={3000}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                onClose={handleSnackBarClose}
            >
                <Alert severity="info" sx={{width: '100%'}}>
                    {snackbar}
                </Alert>
            </Snackbar>
            <Typography component="h1" variant="h5">
                Zubehör
            </Typography>
            <Divider sx={{background: "black", mb: 2}}/>
            <Grid container mt={theme.spacing(2)} direction="row">
                <Grid size={2}>
                    <InfoIcon style={{marginRight: "1em"}}/>
                </Grid>
                <Grid size={10}>
                    <Typography
                        component="p"
                        variant="body2"
                        style={{whiteSpace: 'pre-line'}}
                    >
                        Auf Artikelnummer oder Bezeichnung klicken um den Text in die Zwischenablage zu speichern!
                    </Typography>
                </Grid>
            </Grid>

            {accessories && accessories.length > 0 ? (
                accessories.map((acc) => (
                    <Grid container mt={theme.spacing(2)} direction="row" key={acc.articleNumber + acc.description}>
                        <Grid size={2}>
                            <Typography component="p" variant="body2">
                                <b>{acc.count} {acc.unit === 'piece' ? 'Stk' : "Satz"}</b>
                            </Typography>
                        </Grid>
                        <Grid size={10}>
                            <Typography
                                component="p"
                                variant="body2"
                                sx={{cursor: "pointer"}}
                                onClick={_ => {
                                    navigator.clipboard.writeText(acc.articleNumber)
                                    setSnackbar("Artikelnummer in Zwischenablage kopiert ")
                                }}
                            >
                                <b>{acc.articleNumber}</b>
                            </Typography>
                            <Typography
                                component="p"
                                variant="body2"
                                style={{whiteSpace: 'pre-line'}}
                                sx={{cursor: "pointer"}}
                                onClick={_ => {
                                    navigator.clipboard.writeText(acc.description)
                                    setSnackbar("Artikelbeschreibung in Zwischenablage kopiert")
                                }}
                            >
                                {acc.description}
                            </Typography>
                        </Grid>
                    </Grid>
                ))
            ) : (
                <Typography variant="body2" color="textSecondary">
                    Keine Zubehörartikel vorhanden.
                </Typography>
            )}
        </Paper>
    );
};
